import styled, { createGlobalStyle } from 'styled-components'

// 分享弹窗全局样式（antd Modal 通过 portal 渲染到 body）
export const ShareModalStyle = createGlobalStyle`
    .share-modal {
        .share-song-info {
            display: flex;
            align-items: center;
            padding: 12px 0;
            margin-bottom: 16px;
            border-bottom: 1px solid #f0f0f0;

            img {
                width: 80px;
                height: 80px;
                border-radius: 6px;
                object-fit: cover;
            }

            .share-song-text {
                margin-left: 14px;

                .share-song-name {
                    font-size: 16px;
                    font-weight: 600;
                    color: #333;
                    margin-bottom: 6px;
                }

                .share-song-singer {
                    font-size: 13px;
                    color: #999;
                }
            }
        }

        .share-platforms {
            display: flex;
            flex-direction: column;
            padding: 8px 0 16px;

            .share-item {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                gap: 8px;
                width: 100%;
                padding: 5px;
                margin: 5px;
                border: 1px solid #e8e8e8;
                border-radius: 8px;
                background: #fafafa;
                cursor: pointer;
                transition: all 0.2s;
                font-size: 13px;
                color: #666;
                box-sizing: border-box;

                &:hover {
                    border-color: #c20c0c;
                    color: #c20c0c;
                    background: #fff5f5;
                }

                .share-icon {
                    font-size: 20px;

                    &.link::before {
                        content: '🔗';
                    }
                }
            }
        }
    }
`

// 悬浮歌词容器
export const FloatingLyricWrapper = styled.div`
    position: absolute;
    top: -38px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    max-width: 600px;
    height: 30px;
    padding: 0 12px;
    background: rgba(0, 0, 0, 0.75);
    border-radius: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    z-index: 99;
    white-space: nowrap;
    overflow: hidden;

    .lyric-text {
        color: #fff;
        font-size: 12px;
        line-height: 30px;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .lyric-close {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        margin-left: 8px;
        border: none;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.2);
        color: #fff;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        cursor: pointer;
        transition: background 0.2s;

        &:hover {
            background: rgba(255, 255, 255, 0.4);
        }
    }
`

export const PlaybarWrapper = styled.div`
    position: fixed;
    z-index: 99;
    left: 0;
    right: 0;
    bottom: 0;
    height: 52px;
    background-position: 0 0;
    background-repeat: repeat;

    .content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
        height: 47px;
    }
`

export const ControlWrapper = styled.div<{ $isPlaying: boolean }>`
    display: flex;
    align-items: center;

    .prev,
    .next {
        width: 28px;
        height: 28px;
    }

    .prev {
        background-position: 0 -130px;
    }

    .play {
        width: 36px;
        height: 36px;
        margin: 0 8px;
        background-position: 0 ${props => (props.$isPlaying ? '-165px' : '-204px')};
    }

    .next {
        background-position: -80px -130px;
    }
`

export const PlayInfoWrapper = styled.div`
    display: flex;
    width: 642px;
    align-items: center;

    .image {
        width: 34px;
        height: 34px;
        border-radius: 5px;
    }

    .info {
        flex: 1;
        color: #a1a1a1;
        margin-left: 10px;

        .song {
            color: #e1e1e1;
            position: relative;
            top: 8px;
            left: 8px;

            .singer-name {
                color: #a1a1a1;
                margin-left: 10px;
            }
        }

        .progress {
            display: flex;
            align-items: center;

            .ant-slider {
                width: 493px;
                margin-right: 10px;

                .ant-slider-rail {
                    height: 9px;
                    background: url(${require('@/assets/img/progress_bar.png')}) right 0;
                }

                .ant-slider-track {
                    height: 9px;
                    background: url(${require('@/assets/img/progress_bar.png')}) left -66px;
                }

                .ant-slider-handle {
                   width: 22px;
                    height: 24px;
                    border: none;
                    margin-top: -7px;
                    background: url(${require('@/assets/img/sprite_icon.png')}) 0 -250px;
                    inset-block-start: 2px;

                    // 清除伪元素（关键！hover蓝色框就是::after）
                    &::before,
                    &::after {
                    display: none !important; /\* 直接干掉，比宽高0更彻底 \*/
                    content: none !important;
                    box-shadow: none !important;
                    }
                }
            }

            .time {
                .now-time {
                    color: #e1e1e1;
                }
                .divider {
                    margin: 0 3px;
                }
            }
        }
    }
`

export const OperatorWrapper = styled.div<{ $sequence: number }>`
    display: flex;
    position: relative;
    top: 5px;

    .btn {
        width: 25px;
        height: 25px;
        cursor: pointer;
        transition: filter 0.2s;

        &:hover {
            filter: brightness(1.3);
        }
    }

    .favor {
        background-position: -88px -163px;

        &.active {
            background-position: -88px -189px;
        }
    }

    .share {
        background-position: -114px -163px;
    }

    .left {
        display: flex;
        align-items: center;
    }

    .lyric-toggle {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        margin: 5px;
        border: 2px solid #5a5a5a;
        border-radius: 3px;
        background: transparent;
        color: #9a9a9a;
        font-size: 12px;
        cursor: pointer;
        transition: all 0.2s;

        &:hover {
            color: #fff;
            border-color: #c20c0c;
        }

        &.active {
            color: #c20c0c;
            border-color: #c20c0c;
        }
    }

    .right {
        display: flex;
        align-items: center;
        width: 126px;
        padding-left: 13px;
        background-position: -147px -248px;

        .volume-wrapper {
            position: relative;

            .volume {
                background-position: -2px -248px;

                &.muted {
                    background-position: -104px -69px;
                }
            }

            .volume-slider {
                position: absolute;
                bottom: 22px;
                left: 50%;
                transform: translateX(-50%);
                width: 32px;
                height: 110px;
                padding: 10px 0;
                background: #2d2d2d;
                border: 1px solid #080707;
                border-radius: 4px;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
                z-index: 100;

                // 透明桥接区：消除按钮与滑块之间的间隙，保证 hover 不中断
                &::before {
                    content: '';
                    position: absolute;
                    bottom: -6px;
                    left: 0;
                    width: 100%;
                    height: 6px;
                }

                .slider-inner {
                    height: 90px;
                    display: flex;
                    justify-content: center;

                    .ant-slider {
                        margin: 0;

                        .ant-slider-rail {
                            width: 4px;
                            background: #565656;
                            border-radius: 2px;
                        }

                        .ant-slider-track {
                            width: 4px;
                            background: #c20c0c;
                            border-radius: 2px;
                        }

                        .ant-slider-handle {
                            // antd5: handle 是定位容器，after 才是可见圆点
                            inset-inline-start: 0 !important;

                            &::after {
                                width: 12px;
                                height: 12px;
                                background-color: #fff;
                                box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
                                border: 2px solid #c20c0c;
                            }
                        }
                    }
                }
            }
        }

        .loop {
            background-position: ${props => {
                switch (props.$sequence) {
                    case 1:
                        return '-66px -248px'
                    case 2:
                        return '-66px -344px'
                    default:
                        return '-3px -344px'
                }
            }};
        }

        .playlist {
            padding-left: 18px;
            text-align: center;
            color: #ccc;
            width: 59px;
            background-position: -42px -68px;
            position: relative;

            &-num {
                position: absolute;
                right: 35px;
                line-height: 27px;
                text-align: center;
                color: #666;
                text-shadow: 0 1px 0 #080707;
                text-indent: 0;
            }
        }
    }
`
